import client from './client';
import axios from 'axios';

// TODO: Remove this when checklist will be available in Sanity
const checklistIndividualUrl = 'https://chooosestoragedev.blob.core.windows.net/reduce-checklist/checklist_individual.pdf';
const checklistCompanyUrl = 'https://chooosestoragedev.blob.core.windows.net/reduce-checklist/checklist_company.pdf';

export const getReduceCollection = async (page: string): Promise<SanityReduceCollection> => {
  const query = `
  *[slug.current=="${page}"][0]{
    introTitle,
    introSubtitle,
    introBody,
    introImage{
      asset->{url},
      alt
    },
    pinkBoxTitle,
    pinkBoxBody,
    footerTitle,
    footerBody,
    'items':items[]->{
      _id,
      title,
      preamble,
      description,
      slug,
      reduceCategory->{
        _id,
        title,
        icon{
          asset->{url},
          alt
        }
      }
    }
  }
  `;

  const data = await client.fetch<SanityReduceCollection>(query);

  return data;
};

export const downloadChecklist = async (company?: boolean): Promise<Blob> => {
  const { data } = await axios.get<Blob>(company ? checklistCompanyUrl : checklistIndividualUrl, {
    responseType: 'blob',
  });

  return data;
};
